<template>
  <div id="Peppy">
    <div class="peppy-container content-container pb-5">
      <div class="peppy-content">
        <div class="peppy-row">
          <div class="peppy-title-column">
            <h1 class="peppy-title">
              Peppy together with AXA Health, Personalised support in your
              pocket.
            </h1>
            <p class="peppy-text pt-4">
              Get support and guidance across a range of topics including men’s
              and woman’s health, fertility, early parenthood and menopause
              (depending on the options selected by your employer). Anytime,
              anywhere on the Peppy app.
            </p>
          </div>

          <div class="peppy-image-column">
            <div class="peppy-image-section">
              <img
                src="https://media.spectrum.life/assets/axa/peppy.png"
                alt="Parent and baby"
                class="peppy-image"
              />
            </div>
          </div>
        </div>

        <div class="peppy-bottom-row">
          <div class="peppy-description-column">
            <p class="peppy-subtitle pb-3">
              Access personalised, confidential and free support from human
              experts.
            </p>

            <ul class="points-list">
              <li class="points-item">
                One-to-one chat with an expert (available Monday to Friday 9am -
                9pm GMT)
              </li>
              <li class="points-item">
                One-to-one 40 minute virtual consultations
              </li>
              <li class="points-item">Events</li>
              <li class="points-item">Videos, articles, audios and courses</li>
              <li class="points-item">Mental wellbeing support</li>
              <li class="points-item">Group chat and support</li>
              <li class="points-item">Guidance for symptoms and treatment</li>
            </ul>
          </div>

          <div class="peppy-download-column">
            <div class="download-section">
              <p class="peppy-subtitle pb-3">
                How to get started with Peppy
              </p>
              <ol class="steps-list">
                <li class="step-item">
                  Download and open the Peppy app (instructions below)
                </li>
                <li class="step-item">
                  Choose ‘I get Peppy via AXA Health’ and scroll to click ‘Next’
                </li>
                <li class="step-item">
                  Enter your email address
                </li>
                <li class="step-item">
                  Select which area you would like to receive support for
                </li>
                <li class="step-item">
                  Set up your profile (all information will remain confidential)
                </li>
                <li class="step-item">
                  You’re registered! you will be required to take a short
                  questionnaire to help us deliver the best support for you.
                </li>
              </ol>
              <p class="peppy-subtitle pb-3">
                App users must be 18 years+
              </p>
              <p class="peppy-subtitle pb-3">
                Service is subject to Peppy’s fair usage terms
              </p>
              <div class="button-container pb-3">
                <b-button
                  @click="goToPeppy()"
                  variant="cta"
                  size="lg"
                  squared
                  class="peppy-button"
                >
                  Go to Peppy
                </b-button>
              </div>
              <p class="peppy-subtitle pb-3">
                Download the Peppy app – please note the link will only work on
                mobile
              </p>
              <div class="button-container">
                <b-button
                  @click="downloadPeppy()"
                  variant="cta"
                  size="lg"
                  squared
                  class="peppy-button"
                >
                  Download Peppy App
                </b-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <hr class="horizontal-divider content-container" />
    <div class="pt-5 carousel-container">
      <HomeFilters />
      <HomeCardCarousel
        :title="'Events'"
        type="corporateEvent"
        cardType="corporateEvent"
        class="car"
        :mute="true"
        :preventScroll="true"
      >
      </HomeCardCarousel>
      <HomeCardCarousel
        title="Videos"
        class="car"
        type="standaloneArticles"
        additionalTag="Videos"
        :mute="true"
        :preventScroll="true"
      >
      </HomeCardCarousel>
      <HomeCardCarousel
        title="Articles"
        class="car"
        cardType="article"
        type="standaloneArticles"
        additionalTag="Articles"
        :mute="true"
        :preventScroll="true"
      >
      </HomeCardCarousel>
    </div>
  </div>
</template>

<script>
import HomeFilters from "@/components/Home/New/HomeFilters.vue";
import HomeCardCarousel from "@/components/Home/New/HomeCardCarousel.vue";

export default {
  name: "Peppy",
  components: {
    HomeFilters,
    HomeCardCarousel
  },
  methods: {
    goToPeppy() {
      window.open("https://www.peppy.health/", "_blank");
    },
    downloadPeppy() {
      window.open("https://open.peppy.health/app", "_blank");
    }
  }
};
</script>

<style lang="less" scoped>
#Peppy {
  padding: 70px 0;
  min-height: 100%;
  background-color: #fbfafa;
  width: 100%;
  overflow-x: hidden;

  .peppy-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
    width: 100%;
  }

  .carousel-container {
    width: 100%;
    overflow-x: hidden;
    box-sizing: border-box;
    position: relative;

    .car {
      width: 100%;
      overflow-x: hidden;
    }
  }

  .peppy-content {
    width: 100%;
    display: flex;
    flex-direction: column;
  }

  .peppy-row {
    display: flex;
    flex-direction: row;
    gap: 3rem;
    align-items: flex-start;
    margin-bottom: 3rem;
  }

  .peppy-title-column {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
  }

  .peppy-image-column {
    flex: 1;
    min-width: 0;
  }

  .peppy-bottom-row {
    display: flex;
    flex-direction: row;
    gap: 3rem;
    align-items: flex-start;
    width: 100%;
  }

  .peppy-description-column {
    flex: 1;
    min-width: 0;
  }

  .peppy-download-column {
    flex: 1;
    min-width: 0;
  }

  .peppy-title {
    text-align: left;
    line-height: 1.3;
    margin-bottom: 0;
    color: #00008f;
    letter-spacing: 0;
    font-size: 4.2rem;
    font-weight: bold;
  }

  .peppy-subtitle {
    font-size: 1.8rem;
    font-weight: bold;
    margin-bottom: 0;
  }

  .peppy-text {
    font-size: 1.6rem;
    line-height: 1.7;
    text-align: left;
    margin-bottom: 1.5rem;
    color: #333;
  }

  .peppy-image-section {
    width: 100%;
    display: flex;
    justify-content: center;
  }

  .peppy-image {
    width: 100%;
    max-width: 100%;
    border-radius: 8px;
    object-fit: cover;
  }

  .download-section {
    width: 100%;
  }

  .download-title {
    font-weight: bold;
    font-size: 2rem;
    text-align: left;
    margin-bottom: 1.5rem;
    color: #333;
    letter-spacing: 0;
  }

  .steps-list {
    list-style-position: inside;
    font-size: 1.6rem;
    line-height: 1.8;
    color: #333;
    margin-bottom: 2rem;
    padding-left: 1.5rem;
    margin-top: 0;
  }

  .step-item {
    margin-bottom: 1.2rem;
  }

  .points-list {
    list-style-type: disc;
    list-style-position: outside;
    font-size: 1.6rem;
    line-height: 1.8;
    color: #333;
    margin-bottom: 2rem;
    padding-left: 2rem;
    margin-top: 0;
  }

  .points-list li::marker {
    color: #333;
    font-weight: bold;
  }

  .points-item {
    margin-bottom: 1.2rem;
  }

  .button-container {
    display: flex;
    justify-content: flex-end;
    width: 100%;
    margin-bottom: 2rem;
  }

  .peppy-button {
    min-width: 200px;
  }

  /* Responsive styles */
  @media (max-width: 992px) {
    .peppy-row {
      gap: 2rem;
    }

    .peppy-title {
      font-size: 3rem;
    }
  }

  @media (max-width: 768px) {
    padding: 50px 0;
    width: 100%;
    overflow-x: hidden;

    .peppy-row {
      flex-direction: column;
      gap: 2rem;
      align-items: flex-start;
    }

    .peppy-bottom-row {
      flex-direction: column;
      gap: 2rem;
    }

    .peppy-title {
      font-size: 2.5rem;
    }
  }

  @media (max-width: 576px) {
    padding: 40px 0;
    width: 100%;

    .peppy-container {
      max-width: 100%;
      padding: 0 20px;
    }

    .carousel-container {
      padding: 0;
    }

    .steps-list {
      padding-left: 1rem;
    }

    .peppy-button {
      width: 100%;
    }
  }
}
</style>
